import React, { useState, useEffect } from 'react';
import { Spinner } from 'reactstrap';
import { collection, query, where, getDocs, orderBy, limit } from "firebase/firestore";
import { db } from "../../../../services/firebase";
import { getTier, formatPeriod } from '../utils/professorTiers';

const ProfessorHistoryChart = ({ professor }) => {
    const [historyData, setHistoryData] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;
        const fetchHistory = async () => {
            try {
                const q = query(
                    collection(db, "tenants", professor.idTenant, "performanceSnapshots"),
                    where("idEmployee", "==", professor.idEmployee),
                    where("periodType", "==", "monthly"),
                    orderBy("period", "desc"),
                    limit(6)
                );
                const snap = await getDocs(q);
                if (!isMounted) return;
                
                const docs = snap.docs.map(d => d.data());
                setHistoryData(docs.sort((a, b) => a.period.localeCompare(b.period)));
            } catch (e) {
                console.error("Erro ao buscar histórico:", e);
            } finally {
                if (isMounted) setHistoryLoading(false);
            }
        };
        fetchHistory();
        return () => { isMounted = false; };
    }, [professor.idTenant, professor.idEmployee]);

    return (
        <div style={{ padding: '0 8px', marginBottom: '40px' }}>
            <div className="p-3 p-md-4 d-flex flex-column"
                style={{
                    backgroundColor: 'rgba(255,255,255,0.04)',
                    borderRadius: '20px',
                    border: '1px solid rgba(255,255,255,0.06)',
                    backdropFilter: "blur(10px)",
                    minHeight: '300px'
                }}>
                <div className="mb-3 mt-2 px-1">
                    <h4 className="mb-0 fw-bold font-size-20" style={{ color: "rgba(255,255,255,0.9)" }}>
                        Evolução de Performance
                    </h4>
                    <p className="mt-1 font-size-13" style={{ color: "rgba(255,255,255,0.3)" }}>
                        Comparativo nos últimos 6 ciclos finalizados.
                    </p>
                </div>

                <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-center p-3 rounded-3"
                    style={{ background: "rgba(255,255,255,0.02)" }}>
                    {historyLoading ? (
                        <Spinner color="light" />
                    ) : historyData.length === 0 ? (
                        <div className="text-center py-4">
                            <i className="mdi mdi-chart-line font-size-36" style={{ color: "rgba(255,255,255,0.1)" }}></i>
                            <p className="mt-2 mb-0 font-size-14" style={{ color: "rgba(255,255,255,0.3)" }}>
                                Nenhum histórico encontrado.
                            </p>
                        </div>
                    ) : (
                        <div className="w-100 mt-2">
                            <div className="d-flex justify-content-around align-items-end"
                                style={{ height: "180px", borderBottom: "1px solid rgba(255,255,255,0.08)", paddingBottom: "4px" }}>
                                {historyData.map((s, idx) => {
                                    const tierObj = getTier(s.scoreFinal);
                                    const heightValue = Math.max(10, s.scoreFinal);
                                    const barColor = tierObj.color === '#e9ecef' ? 'rgba(255,255,255,0.2)' : tierObj.color;
                                    
                                    return (
                                        <div key={idx} className="d-flex flex-column align-items-center" style={{ flex: '1 1 0', maxWidth: '60px' }}>
                                            <div className="fw-bold mb-2 font-size-12" style={{ color: barColor }}>
                                                {Number(s.scoreFinal).toFixed(1)}
                                            </div>
                                            <div 
                                                className="w-75 mx-auto" 
                                                style={{ 
                                                    height: `${(heightValue / 100) * 120}px`, 
                                                    backgroundColor: barColor,
                                                    borderTopLeftRadius: "6px",
                                                    borderTopRightRadius: "6px",
                                                    transition: "height 1s ease-out",
                                                    opacity: 0.8,
                                                    boxShadow: `0 0 12px ${barColor}33`
                                                }} 
                                            />
                                            <div className="mt-2 font-size-11 fw-semibold text-center"
                                                style={{ color: "rgba(255,255,255,0.35)", letterSpacing: '-0.3px' }}>
                                                {formatPeriod(s.period)}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProfessorHistoryChart;
